import React from 'react';
export function EntrepriseForm() {
  return <div className="w-full bg-white rounded-3xl shadow-xl border border-slate-100 overflow-hidden" data-id="element-348">
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeCS6XG0ikZm8CIUcshU0XRu-6S-gXo9S-7XP4hz0Hp1RSaCA/viewform?embedded=true" width="100%" height="2748" frameBorder="0" marginHeight={0} marginWidth={0} title="Formulaire entreprise" className="w-full" data-id="element-349">
        Chargement du formulaire…
      </iframe>
    </div>;
}